<template>
  <!-- 员工转岗申请 -->
  <div>
    <Collapse v-model="value2" simple style="border: 0">
      <Panel name="1" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="基本信息" />
        <Form
          ref="formValidate"
          :model="formItem"
          :rules="Validate"
          slot="content"
          :label-width="150"
          label-position="left"
          class="titleDistance"
          :disabled="prevent || isHistory"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工工号">
                <Input placeholder="" v-model="formItem.applyUserId">
                  <Button
                    slot="append"
                    icon="ios-search"
                    @click="select"
                  ></Button>
                </Input>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="员工姓名">
                <Input disabled v-model="formItem.applyName" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="紧急程度">
                <Select
                  v-model="formItem.gradeType"
                  :clearable="true"
                  placeholder=""
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in gradeTypeList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="申请日期">
                <Date-picker
                  v-model="formItem.applyDate"
                  disabled
                  type="date"
                  placeholder=""
                  style="width:100%"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="变更生效日" prop="effectiveDate">
                <Date-picker
                  v-model="formItem.effectiveDate"
                  type="date"
                  placeholder=""
                  style="width:100%"
                ></Date-picker>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="人事变更履历" />
        <Tabs
          :animated="true"
          class="titleDistance"
          slot="content"
          :disabled="prevent"
        >
          <Tab-pane label="人事变更履历" style="width: 100%">
            <Row>
              <Col span="24">
                <Table border :columns="columns1" :data="HRChangeData"></Table>
              </Col>
            </Row>
            <Row>
              <Col
                span="24"
                style="margin-top: 20px; display: flex; justify-content: flex-end;"
              >
                <Page :total="total1" @on-change="pageChange1" />
              </Col>
            </Row>
          </Tab-pane>
        </Tabs>
      </Panel>
      <Panel name="3" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="人事变更" />
        <Form
          :label-width="120"
          slot="content"
          label-position="left"
          class="titleDistance"
          :disabled="prevent || isHistory"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="人事变更类型">
                <Select
                  v-model="formItem.hrChangeType"
                  :clearable="true"
                  placeholder=""
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in HRChangeTypeList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7"> </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构1">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode1"
                  @on-change="
                    (formItem.orgCode2 = ''),
                      (formItem.orgCode3 = ''),
                      (formItem.orgCode4 = ''),
                      (formItem.orgCode5 = ''),
                      (formItem.orgCode6 = ''),
                      (formItem.orgCode7 = ''),
                      (formItem.orgCode8 = ''),
                      (formItem.orgCode9 = ''),
                      (formItem.orgCode10 = ''),
                      getCJCode($event)
                  "
                >
                  <Option
                    v-for="(item, index) in hierarchyOne"
                    :value="item.orgcode1"
                    :key="index"
                    >{{ item.orgcode1 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构2">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode2"
                  @on-change="
                    (formItem.orgCode3 = ''),
                      (formItem.orgCode4 = ''),
                      (formItem.orgCode5 = ''),
                      (formItem.orgCode6 = ''),
                      (formItem.orgCode7 = ''),
                      (formItem.orgCode8 = ''),
                      (formItem.orgCode9 = ''),
                      (formItem.orgCode10 = ''),
                      getCJCode($event)
                  "
                >
                  <Option
                    v-for="(item, index) in hierarchyTwo"
                    :value="item.orgcode2"
                    :key="index"
                    >{{ item.orgcode2 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构3">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode3"
                  @on-change="
                    (formItem.orgCode4 = ''),
                      (formItem.orgCode5 = ''),
                      (formItem.orgCode6 = ''),
                      (formItem.orgCode7 = ''),
                      (formItem.orgCode8 = ''),
                      (formItem.orgCode9 = ''),
                      (formItem.orgCode10 = ''),
                      getCJCode($event)
                  "
                >
                  <Option
                    v-for="(item, index) in hierarchyThree"
                    :value="item.orgcode3"
                    :key="index"
                    >{{ item.orgcode3 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构4">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode4"
                  @on-change="
                    (formItem.orgCode5 = ''),
                      (formItem.orgCode6 = ''),
                      (formItem.orgCode7 = ''),
                      (formItem.orgCode8 = ''),
                      (formItem.orgCode9 = ''),
                      (formItem.orgCode10 = ''),
                      getCJCode($event)
                  "
                >
                  <Option
                    v-for="(item, index) in hierarchyFour"
                    :value="item.orgcode4"
                    :key="index"
                    >{{ item.orgcode4 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构5">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode5"
                  @on-change="
                    (formItem.orgCode6 = ''),
                      (formItem.orgCode7 = ''),
                      (formItem.orgCode8 = ''),
                      (formItem.orgCode9 = ''),
                      (formItem.orgCode10 = ''),
                      getCJCode($event)
                  "
                >
                  <Option
                    v-for="(item, index) in hierarchyFive"
                    :value="item.orgcode5"
                    :key="index"
                    >{{ item.orgcode5 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构6">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode6"
                  @on-change="
                    (formItem.orgCode7 = ''),
                      (formItem.orgCode8 = ''),
                      (formItem.orgCode9 = ''),
                      (formItem.orgCode10 = ''),
                      getCJCode($event)
                  "
                >
                  <Option
                    v-for="(item, index) in hierarchySix"
                    :value="item.orgcode6"
                    :key="index"
                    >{{ item.orgcode6 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构7">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode7"
                  @on-change="
                    (formItem.orgCode8 = ''),
                      (formItem.orgCode9 = ''),
                      (formItem.orgCode10 = ''),
                      getCJCode($event)
                  "
                >
                  <Option
                    v-for="(item, index) in hierarchySeven"
                    :value="item.orgcode7"
                    :key="index"
                    >{{ item.orgcode8 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构8">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode8"
                  @on-change="
                    (formItem.orgCode9 = ''),
                      (formItem.orgCode10 = ''),
                      getCJCode($event)
                  "
                >
                  <Option
                    v-for="(item, index) in hierarchyEight"
                    :value="item.orgcode8"
                    :key="index"
                    >{{ item.orgcode8 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构9">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode9"
                  @on-change="(formItem.orgCode10 = ''), getCJCode($event)"
                >
                  <Option
                    v-for="(item, index) in hierarchyNine"
                    :value="item.orgcode9"
                    :key="index"
                    >{{ item.orgcode9 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="组织架构10">
                <Select
                  placeholder=""
                  clearable
                  v-model="formItem.orgCode10"
                  @on-change="getCJCode"
                >
                  <Option
                    v-for="(item, index) in hierarchyTen"
                    :value="item.orgcode10"
                    :key="index"
                    >{{ item.orgcode10 }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="是否已告知本人">
                <Checkbox
                  v-model="formItem.beNotifyOneself"
                  true-value="1"
                  fasle-value="0"
                ></Checkbox>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="鞋柜是否调整">
                <Checkbox
                  v-model="formItem.beShoes"
                  true-value="1"
                  fasle-value="0"
                ></Checkbox>
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="衣柜是否调整">
                <Checkbox
                  v-model="formItem.beWardrobe"
                  true-value="1"
                  fasle-value="0"
                ></Checkbox>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="班车是否调整">
                <Checkbox
                  v-model="formItem.beBus"
                  true-value="1"
                  fasle-value="0"
                ></Checkbox>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="班车原路线">
                <Input v-model="formItem.busOriginalRoute" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="班车新路线">
                <Input v-model="formItem.busNewRoute" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="预定职位（原）">
                <Input v-model="formItem.reservePositionOriginal" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="预定职位（新）">
                <Input v-model="formItem.reservePositionNew" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="成本中心">
                <Input v-model="formItem.costCenter" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="24">
              <FormItem span="3" label="变更原因">
                <Input type="textarea" v-model="formItem.changeReason" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Panel>
      <Panel name="4" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="职位变更履历" />
        <Tabs
          :animated="true"
          class="titleDistance"
          slot="content"
          :disabled="prevent"
        >
          <Tab-pane label="职位变更履历" style="width: 100%">
            <Row>
              <Col span="24">
                <Table
                  border
                  :columns="columns4"
                  :data="positionChangeDate"
                ></Table>
              </Col>
            </Row>
            <Row>
              <Col
                span="24"
                style="margin-top: 20px; display: flex; justify-content: flex-end;"
              >
                <Page :total="total2" @on-change="pageChange2" />
              </Col>
            </Row>
          </Tab-pane>
        </Tabs>
      </Panel>
      <Panel name="5" hide-arrow style="margin-bottom: 20px; border: 0">
        <FormTitle titleText="职位信息" />
        <Form
          :label-width="150"
          slot="content"
          label-position="left"
          class="titleDistance"
          :disabled="prevent || isHistory"
        >
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="职位编号">
                <Input disabled v-model="formItem.positionNo">
                  <Button
                    slot="append"
                    icon="ios-search"
                    @click="(showPosition = true), getPosition()"
                  ></Button>
                </Input>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="职位描述（中文）">
                <Input disabled v-model="formItem.positionCname" />
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="职位描述（英文）">
                <Input disabled v-model="formItem.positionEname" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="职位变更原因">
                <Select
                  v-model="formItem.positionChangeReason"
                  :clearable="true"
                  placeholder=""
                >
                  <Option
                    :value="item.code"
                    v-for="(item, i) in changeReasonList"
                    :key="i"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="直线主管">
                <Input placeholder="" v-model="formItem.lineSupervisor">
                  <Button
                    slot="append"
                    icon="ios-search"
                    @click="selectExecutive"
                  ></Button>
                </Input>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :md="24" :lg="7">
              <FormItem label="直线主管职位">
                <Input v-model="formItem.lineSupervisorPosition" />
              </FormItem>
            </Col>
          </Row>
          <Row type="flex" justify="space-between">
            <Col span="18">
              <div class="form-inline">
                <FormItem label="附件" style="margin-top:15px">
                  <j2-FileUP
                    ref="file1"
                    @handleDel="fileDel"
                    @handleOK="fileSuc"
                    :disabled="isHistory"
                    :file_type="{ resourceType: 'Transfer_Attachment' }"
                    :resourceId="formItem.file_attachment"
                  ></j2-FileUP>
                </FormItem>
              </div>
            </Col>
          </Row>
        </Form>
      </Panel>
    </Collapse>
    <Row class="btnRight">
      <Col>
        <Button class="applyBtnRight" @click="importCG" v-if="!isHistory"
          >导入草稿</Button
        >
        <Button class="applyBtnRight" @click="saveCG" v-if="!isHistory"
          >保存草稿</Button
        >
        <Button class="applyBtnRight" v-if="!isHistory" @click="submitt">{{
          $t("提交")
        }}</Button>
        <Button class="applyBtnRight" @click="returnPage">{{
          $t("返回")
        }}</Button>
      </Col>
    </Row>
    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1" />
    <j2-DraftPop ref="cgPop" />
    <!-- 审批历史 -->
    <div v-if="isHistory">
      <FormTitle titleText="审批历史" style="margin-top: 30px" />
      <Table border :columns="columns3" :data="data3" class="titleDistance">
      </Table>
    </div>
    <!-- 选择员工弹窗 -->
    <Modal v-model="empoloyee" title="选择员工" width="860px">
      <Form :model="filter" inline :label-width="50" label-position="left">
        <FormItem label="员工工号" :label-width="85">
          <Input
            type="text"
            v-model="filter.empCode"
            placeholder="请输入员工工号"
            style="width: 150px"
          ></Input>
        </FormItem>
        <FormItem label="员工姓名" :label-width="100">
          <Input
            type="text"
            v-model="filter.userName"
            placeholder="请输入员工姓名"
            style="width: 150px"
          ></Input>
        </FormItem>
        <Button
          type="primary"
          @click="(total = 0), (pageInfo.pageNum = 1), getp()"
          ><!-- 检索 -->{{ $t("Search") }}</Button
        >
      </Form>
      <Table
        ref="myTable"
        :loading="loading"
        :columns="columns2"
        :data="data2"
        border
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="select1(row, index)"
            >选择</Button
          >
        </template>
      </Table>
      <div class="pageBox">
        <div></div>
        <Page :total="total" @on-change="pageChange" style="margin-top:10px" />
      </div>
      <div slot="footer">
        <Button type="text" @click="handleCancle">取消</Button>
      </div>
    </Modal>
    <!-- 选择主管弹窗 -->
    <Modal v-model="executive" title="选择主管" width="860px">
      <Form :model="filter1" inline :label-width="50" label-position="left">
        <FormItem label="主管工号" :label-width="85">
          <Input
            type="text"
            v-model="filter1.empcode"
            placeholder="请输入主管工号"
            style="width: 150px"
          ></Input>
        </FormItem>
        <FormItem label="主管姓名" :label-width="100">
          <Input
            type="text"
            v-model="filter1.cName"
            placeholder="请输入主管姓名"
            style="width: 150px"
          ></Input>
        </FormItem>
        <Button
          type="primary"
          @click="(total3 = 0), (pageInfo3.pageNum = 1), getExecutive()"
          ><!-- 检索 -->{{ $t("Search") }}</Button
        >
      </Form>
      <Table
        ref="myTable"
        :loading="loading"
        :columns="columns5"
        :data="data5"
        border
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="select1Executive(row, index)"
            >选择</Button
          >
        </template>
      </Table>
      <div>
        <div></div>
        <Page
          :total="total3"
          @on-change="pageChange3"
          style="margin-top:10px"
        />
      </div>
      <div slot="footer">
        <Button type="text" @click="executive = false">取消</Button>
      </div>
    </Modal>
    <!-- 选择职位编号弹窗 -->
    <Modal v-model="showPosition" title="选择职位编号" width="860px">
      <Form :model="filter2" inline :label-width="90" label-position="left">
        <FormItem label="职位编码">
          <Input
            type="text"
            v-model="filter2.positionNo"
            placeholder=""
            style="width: 150px"
          ></Input>
        </FormItem>
        <FormItem label="中文描述">
          <Input
            type="text"
            v-model="filter2.positionCname"
            placeholder=""
            style="width: 150px"
          ></Input>
        </FormItem>
        <FormItem label="英文描述">
          <Input
            type="text"
            v-model="filter2.positionEname"
            placeholder=""
            style="width: 150px"
          ></Input>
        </FormItem>
        <Button
          type="primary"
          @click="(total6 = 0), (pageInfo6.pageNum = 1), getPosition()"
          ><!-- 检索 -->{{ $t("Search") }}</Button
        >
      </Form>
      <Table
        ref="myTable"
        :loading="loading"
        :columns="columns6"
        :data="data6"
        border
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="selectPosition(row, index)"
            >选择</Button
          >
        </template>
      </Table>
      <div>
        <div></div>
        <Page
          :total="total6"
          @on-change="pageChange6"
          style="margin-top:10px"
        />
      </div>
      <div slot="footer">
        <Button type="text" @click="showPosition = false">取消</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      value2: [1, 2, 3, 4, 5],
      formItem: {
        status: ""
      },
      Validate: {
        effectiveDate: [{ required: true, message: "请选择变更生效日" }]
      },
      formItem2: {},
      filter: {},
      filter1: {},
      filter2: {},
      fileInfo: {
        transferFile: ""
      },
      action: "/api/resource/upload",
      empoloyee: false,
      executive: false,
      columns1: [
        {
          title: "变更有效日",
          key: "effectiveDate",
          align: "center",
          width: "200",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.effectiveDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "组织架构1",
          key: "orgCode1",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构2",
          key: "orgCode2",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构3",
          key: "orgCode3",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构4",
          key: "orgCode4",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构5",
          key: "orgCode5",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构6",
          key: "orgCode6",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构7",
          key: "orgCode7",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构8",
          key: "orgCode8",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构9",
          key: "orgCode9",
          align: "center",
          width: "200"
        },
        {
          title: "组织架构10",
          key: "orgCode10",
          align: "center",
          width: "200"
        }
      ],
      HRChangeData: [], //人事变更履历
      columns4: [
        {
          title: "职位开始日",
          key: "effectiveDate",
          align: "center",
          width: "200",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.effectiveDate, "YYYY-MM-DD")
            );
          }
        },
        {
          title: "职位编号",
          key: "positionNo",
          align: "center"
        },
        {
          title: "职位描述（中文）",
          key: "positionCname",
          align: "center"
        },
        {
          title: "职位描述（英文）",
          key: "positionEname",
          align: "center"
        },
        {
          title: "职位变更原因",
          key: "positionChangeReason",
          align: "center",
          render: (h, params) => {
            var position = "";
            this.changeReasonList.forEach(item => {
              if (params.row.positionChangeReason == item.code) {
                position = item.name;
              }
            });
            return h("span", position);
          }
        }
      ],
      positionChangeDate: [], //职位变更履历
      data2: [], //员工数据
      gradeTypeList: [], //紧急程度下拉框
      HRChangeTypeList: [], //人事变更类型下拉框
      changeReasonList: [], //职位变更原因
      isReadonly: false,
      columns2: [
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "150"
        },
        {
          title: "员工工号",
          key: "empCode",
          align: "center"
        },
        {
          title: "员工姓名",
          key: "userName",
          align: "center"
        },
        {
          title: "职位名称",
          key: "positionName",
          align: "center"
        }
      ],
      pageInfo: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      pageInfo1: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total1: 0,
      pageInfo2: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total2: 0,
      columns5: [
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "150"
        },
        {
          title: "主管工号",
          key: "empcode",
          align: "center"
        },
        {
          title: "主管姓名",
          key: "cname",
          align: "center"
        },
        {
          title: "职位名称",
          key: "positionName",
          align: "center"
        }
      ],
      data5: [], //主管数据
      pageInfo3: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total3: 0,
      columns6: [
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: "150"
        },
        {
          title: "职位编码",
          key: "positionNo",
          align: "center"
        },
        {
          title: "中文描述",
          key: "positionCname",
          align: "center"
        },
        {
          title: "英文描述",
          key: "positionEname",
          align: "center"
        }
      ],
      data6: [],
      pageInfo6: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10
      },
      total6: 0,
      showPosition: false,
      columns3: [
        {
          title: "审批流名称",
          key: "stepName",
          align: "center",
          width: "280"
        },
        {
          title: "实际审批者",
          key: "userName",
          align: "center",
          width: "280"
        },
        {
          title: "审批时间",
          key: "time",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
            );
          }
        },
        {
          title: "审批状态",
          key: "status",
          align: "center",
          width: "280",
          render: (h, params) => {
            return h(
              "span",
              params.row.status == "0"
                ? "通过"
                : params.row.status == "1"
                ? "驳回"
                : ""
            );
          }
        },
        {
          title: "审批意见",
          key: "message",
          align: "center",
          width: "465"
        }
      ],
      data3: [], //审批历史
      spinShow: false,
      prevent: false,
      isHistory: false,
      resourceId_List: [],
      serialnumber: null,
      hierarchyOne: [],
      hierarchyTwo: [],
      hierarchyThree: [],
      hierarchyFour: [],
      hierarchyFive: [],
      hierarchySix: [],
      hierarchySeven: [],
      hierarchyEight: [],
      hierarchyNine: [],
      hierarchyTen: [],
      loading: false
    };
  },
  created() {
    if (this.getQueryVariable("history")) {
      this.isHistory = true;
    }
  },
  watch: {},
  mounted() {
    this.getOptionList();
    this.getHistoryData();
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  methods: {
    //打开草稿列表
    importCG() {
      this.$refs.cgTem.getInternation();
      this.$refs.cgTem.popShow(
        "TF01",
        JSON.parse(sessionStorage.getItem("userInfo")).userId
      ); //草稿type 操作人
    },
    //保存草稿
    saveCG() {
      this.$refs.cgPop.getInternation();
      //草稿type 草稿内容
      if (this.$refs.file1 && this.$refs.file1.fileName != null) {
        this.formItem.file_attachment = this.$refs.file1.resource_id;
        this.formItem.file_attachment_name = this.$refs.file1.fileName;
      }
      this.formItem.applyDate = this.date.dateVal(
        this.formItem.applyDate,
        "YYYY-MM-DD"
      );
      this.formItem.effectiveDate = this.date.dateVal(
        this.formItem.effectiveDate,
        "YYYY-MM-DD"
      );
      this.$refs.cgPop.popShow("TF01", {
        formItem: this.formItem,
        HRChangeData: this.HRChangeData,
        positionChangeDate: this.positionChangeDate
      });
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      var obj = JSON.parse(row.draftContent);
      this.formItem = obj.formItem;
      this.HRChangeData = obj.HRChangeData;
      this.positionChangeDate = obj.positionChangeDate;
      this.$refs.file1.resource_id = this.formItem.file_attachment;
      this.$refs.file1.fileName = this.formItem.file_attachment_name;
      this.getCJCode();
    },
    // 上传附件
    fileSuc(res_id) {
      this.formItem.file_attachment = res_id;
    },
    fileDel(res_id) {
      this.formItem.file_attachment = "";
      this.resourceId_List.push(res_id);
    },
    //查询历史信息
    getHistoryData() {
      if (this.isHistory) {
        let arr = {
          instanceId: this.getQueryVariable("instanceId")
        };
        axios.post("/transfer/selectTransferData", arr).then(res => {
          this.formItem = res.basicInfo;
          this.data3 = res.logMap;
          this.positionChangeDate = res.transferOrgHistoricals;
          this.HRChangeData = res.transferOrgHistoricals;
          this.getCJCode();
          if (this.formItem.fileName && this.formItem.fileattachment) {
            this.$refs.file1.resource_id = this.formItem.fileattachment;
            this.$refs.file1.fileName = this.formItem.fileName;
          }
        });
      }
    },
    select1(row) {
      this.$set(this.formItem, "applyUserId", row.empCode);
      this.$set(this.formItem, "applyName", row.userName);
      this.$set(this.formItem, "applySerialnumber", row.serialnumber);
      this.formItem.applyDate = this.date.dateVal(new Date(), "YYYY-MM-DD");
      this.empoloyee = false;
      this.getListDate();
      console.log(this.formItem, "this.formItem");
    },
    //查询选择员工的信息
    getListDate() {
      let obj = {
        serialnumber: this.formItem.applySerialnumber
      };
      this.loading = true;
      axios.post("/transfer/selectOrgAndPosition", obj).then(res => {
        this.HRChangeData = res;
        this.positionChangeDate = res;
        this.getCJCode();
        this.loading = false;
        console.log(this.HRChangeData, "HRChangeData");
      });
    },
    getCJCode() {
      let obj = {};
      this.$set(obj, "orgCode1", this.formItem.orgCode1);
      this.$set(obj, "orgCode2", this.formItem.orgCode2);
      this.$set(obj, "orgCode3", this.formItem.orgCode3);
      this.$set(obj, "orgCode4", this.formItem.orgCode4);
      this.$set(obj, "orgCode5", this.formItem.orgCode5);
      this.$set(obj, "orgCode6", this.formItem.orgCode6);
      this.$set(obj, "orgCode7", this.formItem.orgCode7);
      this.$set(obj, "orgCode8", this.formItem.orgCode8);
      this.$set(obj, "orgCode9", this.formItem.orgCode9);
      this.$set(obj, "orgCode10", this.formItem.orgCode10);
      let obj1 = {
        orgCode1: this.formItem.orgCode1 || "",
        orgCode2: this.formItem.orgCode2 || "",
        orgCode3: this.formItem.orgCode3 || "",
        orgCode4: this.formItem.orgCode4 || "",
        orgCode5: this.formItem.orgCode5 || "",
        orgCode6: this.formItem.orgCode6 || "",
        orgCode7: this.formItem.orgCode7 || "",
        orgCode8: this.formItem.orgCode8 || "",
        orgCode9: this.formItem.orgCode9 || "",
        orgCode10: this.formItem.orgCode10 || ""
      };
      axios.post("/transfer/selectOrgList", obj1).then(res => {
        this.hierarchyTwo = [];
        this.hierarchyThree = [];
        this.hierarchyFour = [];
        this.hierarchyFive = [];
        this.hierarchySix = [];
        this.hierarchySeven = [];
        this.hierarchyEight = [];
        this.hierarchyNine = [];
        this.hierarchySeven = [];
        this.$set(this.formItem, "orgCode1", obj.orgCode1);
        this.$set(this.formItem, "orgCode2", obj.orgCode2);
        this.$set(this.formItem, "orgCode3", obj.orgCode3);
        this.$set(this.formItem, "orgCode4", obj.orgCode4);
        this.$set(this.formItem, "orgCode5", obj.orgCode5);
        this.$set(this.formItem, "orgCode6", obj.orgCode6);
        this.$set(this.formItem, "orgCode7", obj.orgCode7);
        this.$set(this.formItem, "orgCode8", obj.orgCode8);
        this.$set(this.formItem, "orgCode9", obj.orgCode9);
        this.$set(this.formItem, "orgCode10", obj.orgCode10);
        if (res) {
          this.hierarchyOne = res.hierarchyone ? res.hierarchyone : null;
          this.hierarchyTwo = res.hierarchytwo ? res.hierarchytwo : null;
          this.hierarchyThree = res.hierarchythree ? res.hierarchythree : null;
          this.hierarchyFour = res.hierarchyfour ? res.hierarchyfour : null;
          this.hierarchyFive = res.hierarchyfive ? res.hierarchyfive : null;
          this.hierarchySix = res.hierarchysix ? res.hierarchysix : null;
          this.hierarchySeven = res.hierarchyseven ? res.hierarchyseven : null;
          this.hierarchyEight = res.hierarchyeight ? res.hierarchyeight : null;
          this.hierarchyNine = res.hierarchynine ? res.hierarchynine : null;
          this.hierarchyTen = res.hierarchyten ? res.hierarchyten : null;
        }
      });
    },
    select() {
      this.empoloyee = true;
      this.getp();
    },
    //全部员工查询
    getp() {
      this.loading = true;
      let arr = {
        ...this.filter,
        pageNo: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      axios.post("/transfer/selectTransferUser", arr).then(res => {
        this.loading = false;
        if (res) {
          this.data2 = res.data;
          this.total = Number(res.pageInfo.total);
        }
      });
    },
    //员工查询分页
    pageChange(val) {
      this.pageInfo.pageNum = val;
      this.getp();
    },
    selectExecutive() {
      this.executive = true;
      this.getExecutive();
    },
    //主管查询
    select1Executive(row) {
      this.formItem.lineSupervisor = row.cname;
      this.formItem.lineSupervisorPosition = row.positionName;
      this.formItem.serialnumber = row.serialnumber;
      this.executive = false;
    },
    getExecutive() {
      this.loading = true;
      let arr = {
        ...this.filter1,
        pageNo: this.pageInfo3.pageNum,
        pageSize: this.pageInfo3.pageSize
      };
      axios.post("/transfer/selectTransferExecutive", arr).then(res => {
        this.loading = false;
        if (res) {
          this.data5 = res.data;
          this.total3 = Number(res.pageInfo.total);
        }
      });
    },
    //主管查询分页
    pageChange3(val) {
      this.pageInfo3.pageNum = val;
      this.getExecutive();
    },
    //人事变更履历分页
    pageChange1(val) {
      this.pageInfo1.pageNum = val;
      this.getListDate();
    },
    //职位变更履历分页
    pageChange2(val) {
      this.pageInfo2.pageNum = val;
      this.getListDate();
    },
    handleCancle() {
      this.empoloyee = false;
      this.loading = false;
    },
    getPosition() {
      let obj = {
        ...this.filter2,
        pageNo: this.pageInfo6.pageNum,
        pageSize: this.pageInfo6.pageSize,
        orgCode1: this.formItem.orgCode1 || null,
        orgCode2: this.formItem.orgCode2 || null,
        orgCode3: this.formItem.orgCode3 || null,
        orgCode4: this.formItem.orgCode4 || null,
        orgCode5: this.formItem.orgCode5 || null,
        orgCode6: this.formItem.orgCode6 || null,
        orgCode7: this.formItem.orgCode7 || null,
        orgCode8: this.formItem.orgCode8 || null,
        orgCode9: this.formItem.orgCode9 || null,
        orgCode10: this.formItem.orgCode10 || null
      };
      this.loading = true;
      axios.post("/transfer/selectPositionCode", obj).then(res => {
        this.loading = false;
        if (res) {
          this.data6 = res.data;
          this.total6 = Number(res.pageInfo.total);
        }
      });
    },
    pageChange6(val) {
      this.pageInfo6.pageNum = val;
      this.getPosition();
    },
    selectPosition(row, index) {
      this.formItem.positionCname = row.positionCname;
      this.formItem.positionEname = row.positionEname;
      this.formItem.positionNo = row.positionNo;
      this.showPosition = false;
    },
    //查询下拉框
    getOptionList() {
      let arr = {};
      axios.post("/transfer/selectOptionList", arr).then(res => {
        this.gradeTypeList = res.filter(res => {
          if (res.type == "grade") return res;
        }); //紧急程度下拉框
        this.HRChangeTypeList = res.filter(res => {
          if (res.type == "personnel") return res;
        }); //人事变更类型下拉框
        this.changeReasonList = res.filter(res => {
          if (res.type == "CHANGEREASON") return res;
        }); //职位变更原因
      });
    },
    submitt() {
      let flag = false;
      this.$refs["formValidate"].validate(valid => {
        if (!valid) {
          flag = true;
        }
      });
      if (flag) {
        this.$Message.error("请填写变更生效日！");
        return;
      }
      this.$Modal.confirm({
        title: this.$notice("submission"),
        content: "",
        onOk: () => {
          this.prevent = true;
          this.handle();
        },
        onCancel: () => {}
      });
    },
    handle() {
      this.formItem.applyDate = this.date.dateVal(
        this.formItem.applyDate,
        "YYYY-MM-DD"
      );
      this.formItem.effectiveDate = this.date.dateVal(
        this.formItem.effectiveDate,
        "YYYY-MM-DD"
      );
      let obj = JSON.parse(JSON.stringify(this.formItem));
      obj = this.toLine(obj);
      let arr = [
        {
          objData1: {
            create_user_id: JSON.parse(sessionStorage.getItem("userInfo"))
              .userId,
            update_user_id: JSON.parse(sessionStorage.getItem("userInfo"))
              .serialnumber,
            // apply_name: JSON.parse(window.sessionStorage.getItem("userInfo")).userName,
            serialnumber: this.formItem.serialnumber,
            ...obj,
            line_supervisor_id: this.formItem.serialnumber
          },
          stringData1: "TF01",
          // stringData10: this.formItem.userName, //字段无
          type: "B31"
        }
      ];
      this.spinShow = true;
      axios.post("/process/execute", arr).then(res => {
        this.HRChangeData.forEach(item => {
          item.serialnumber = this.formItem.applySerialnumber;
          // item.empcode = this.formItem.transferEmpcode;
          item.instanceId = res[0];
        });
        axios
          .post("/transfer/insertOrgAndPosition", this.HRChangeData)
          .then(res1 => {
            this.spinShow = false;
            if (res1) {
              if (this.resourceId_List.length > 0) {
                this.$removeFile(this.resourceId_List);
              }
              this.$Message.info(this.$t("sbumit_Success"));
              this.$router.push(
                "/479EB7C68FD1C711E1668077E8206CA1/A3FFBEBFDB713E27"
              );
            }
          });
      });
    },
    returnPage() {
      if (this.isHistory) {
        this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
      } else {
        this.$router.go(-1);
      }
    },
    toLine(name) {
      let arr = Object.keys(name);
      let arr1 = Object.values(name);
      let obj = {};
      for (let i = 0; i < arr.length; i++) {
        obj[arr[i].replace(/([A-Z])/g, "_$1").toLowerCase()] = arr1[i];
      }
      return obj;
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>

<style scoped>
.titleDistance {
  margin: 30px 30px 0 30px;
}
.ivu-input-search {
  cursor: pointer;
  padding: 0 16px !important;
  color: #000 !important;
  background: #f8f8f9 !important;
  border-color: #dcdee2 !important;
  transition: all 0.2s ease-in-out;
  position: relative;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/TransferApply.vue